import { render, staticRenderFns } from "./AssigneeMenu.vue?vue&type=template&id=2edff8dc&"
import script from "./AssigneeMenu.vue?vue&type=script&lang=js&"
export * from "./AssigneeMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports